import { Box, Flex, Spoiler, Text } from '@mantine/core';
import { IconChevronDown, IconChevronUp } from '@tabler/icons-react';
import { useState } from 'react';

import type { VacancyTariff } from '../api/types';

import classes from './TariffCard.module.scss';

type TariffCardProps = {
  tariff: VacancyTariff;
  /** Без внешней белой оболочки — для строки выбора (модалка) */
  embedded?: boolean;
  selected?: boolean;
};

const formatPrice = ({ price, symbol }: { price: number; symbol: string }) => {
  const formatted = price.toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });

  return `${symbol} ${formatted}`;
};

export const TariffCard = ({
  tariff,
  embedded = false,
  selected = false,
}: TariffCardProps) => {
  const [expanded, setExpanded] = useState(false);

  const inner = (
    <Flex direction='column' gap={16} w='100%'>
      <Flex direction='column' gap={8} w='100%'>
        <Text c='primary.7' size='md' fw={600}>
          {tariff.name}
        </Text>

        <Spoiler
          w='100%'
          maxHeight={48}
          expanded={expanded}
          onExpandedChange={setExpanded}
          classNames={classes}
          showLabel={
            <Flex gap={4} align='center' component='span'>
              <Text c='secondary.7' size='xs' fw={600} component='span'>
                Показать
              </Text>
              <IconChevronDown
                size={16}
                color='var(--mantine-color-secondary-7)'
              />
            </Flex>
          }
          hideLabel={
            <Flex gap={4} align='center' component='span'>
              <Text c='secondary.7' size='xs' fw={600} component='span'>
                Скрыть
              </Text>
              <IconChevronUp
                size={16}
                color='var(--mantine-color-secondary-7)'
              />
            </Flex>
          }
          styles={{
            control: { textDecoration: 'none' },
          }}
        >
          <Box>
            <Box
              style={{ opacity: !expanded ? 1 : 0 }}
              className={classes.gradient}
              data-selected={selected}
            />
            <Text c='primary.7' size='sm'>
              {tariff.description}
            </Text>
          </Box>
        </Spoiler>
      </Flex>

      <Flex
        justify='space-between'
        align='center'
        pt={16}
        gap='md'
        style={{
          borderTop: '1px solid var(--mantine-color-tertiary-2)',
        }}
      >
        <Text c='tertiary.7' size='sm' flex={1}>
          Стоимость
          <br />
          за выбранного кандидата
        </Text>
        <Text size='xl' fw={600} c='primary.7'>
          {formatPrice({
            price: tariff.price,
            symbol: tariff.currency.value,
          })}
        </Text>
      </Flex>
    </Flex>
  );

  if (embedded) {
    return inner;
  }

  return (
    <Box w='100%' p={16} bg='white' style={{ borderRadius: 12 }}>
      {inner}
    </Box>
  );
};
